export enum AppLanguage {
  Czech = 'cs',
  English = 'en',
  Croatian = 'hr',
  Slovak = 'sk',
  Hungarian = 'hu',
}
